import { pad } from './utils.js'

const MONTH_NAMES_SHORT = [
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ',
]

const WEEKDAY_NAMES_SHORT = ['DOM', 'SEG', 'TER', 'QUA', 'QUI', 'SEX', 'SAB']

export function formatDate(date, mask) {
  const map = {
    YYYY: date.getUTCFullYear(),
    YY: String(date.getFullYear()).slice(-2),
    MMM: MONTH_NAMES_SHORT[date.getUTCMonth()],
    MM: pad(date.getUTCMonth() + 1),
    DDD: WEEKDAY_NAMES_SHORT[date.getUTCDay()],
    DD: pad(date.getUTCDate()),
    HH: pad(date.getHours()),
    mm: pad(date.getUTCMinutes()),
    ss: pad(date.getUTCSeconds()),
    sss: pad(date.getMilliseconds()),
  }
  return mask
    ? mask.replace(/YYYY|YY|MMM|MM|DDD|DD|HH|mm|ss|SS/g, (match) => map[match])
    : date
}
